import { render, staticRenderFns } from "./statsPage.vue?vue&type=template&id=0eeade0e&scoped=true"
import script from "./statsPage.vue?vue&type=script&lang=js"
export * from "./statsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eeade0e",
  null
  
)

export default component.exports